import { createTrackingUtils } from "../index";
import useProfiler from "hooks/useProfiler";
import { useSplitBoundsCondition } from "utils/experiments/funnel/flights_split_bounds_us";

const utils = createTrackingUtils({
  name: "flights_web_trip_type_dropdown_mdot",
  stages: {
    main: 1,
    index: 2,
    sr: 3,
    direct: 4,
    meta: 5,
    solo: 6,
    nonSolo: 7,
    us: 8,
    splitBound: 9
  },
  defaultStage: 1,
  goals: {
    searchMadeRoundTrip: 1,
    searchMadeOneWay: 2,
    searchMadeMultiCity: 3
  }
});

export const useTrackTripTypeDropdownMobile = () => {
  const { stages } = utils;
  const { isDirect, isMeta, isSolo, isAmerican } = useProfiler();
  const { isSplitBounds } = useSplitBoundsCondition();

  isDirect() && stages.direct();
  isMeta() && stages.meta();
  isSolo() ? stages.solo() : stages.nonSolo();
  isAmerican() && stages.us();
  isSplitBounds && stages.splitBound();
};

export default utils;
